import styled from "styled-components";

export default styled.div`
  width: 100%;
  padding: 7px 0px 7px 10px;
  font-size: 14px;
  border-bottom: 1px solid rgba(185, 185, 185, 0.1);
  p {
    display: inline-block;
    margin: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Incident.js